import React, { ReactNode } from 'react';
import cn from 'classnames';

interface Props {
  children: ReactNode;
  className?: string;
}

const InputError = ({ children, className }: Props) => {
  return (
    <span className={cn('block', 'mb-2', 'text-abn-red', 'text-xs', className)}>
      {children}
    </span>
  );
};

export default InputError;
